var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasFeatures)?_c('vm-source',{attrs:{"name":"atrativos-source","type":"geojson","options":{ data: _vm.geoJSON },"minzoom":11}},[_c('vm-image',{attrs:{"name":"atrativo_dump","url":"/images/atrativo_dump.svg"}}),_vm._l((_vm.computedIcons),function(v,k){return _c('vm-image',{key:k,attrs:{"name":k,"url":v}})}),_c('vm-layer',{attrs:{"name":"atrativos","filter":['==', '$type', 'Point'],"type":"symbol","paint":{
      'text-color': 'white',
      'text-halo-color': 'white',
      'text-halo-width': 0.4,
      'text-halo-blur': 0.2,
      'text-opacity': {
        base: 1,
        stops: [
          [16, 0],
          [17.5, 1]
        ]
      },
      'icon-opacity': {
        base: 1,
        stops: [
          [9, 0],
          [11, 0],
          [11.1, 1],
          [14, 1],
          [15, 1]
        ]
      }
    },"layout":{
      'icon-image': [
        'coalesce',
        ['image', ['get', 'imagemnome']],
        ['image', 'atrativo_dump']
      ],
      'icon-anchor': 'bottom',
      'icon-allow-overlap': false,
      'text-field': '{nome}',
      'text-anchor': 'top',
      'text-line-height': 1,
      'text-optional': true,
      'text-offset': {
        base: 1,
        stops: [[14, [0, 1.5]]]
      },
      'text-padding': 0,
      'text-size': {
        base: 1,
        stops: [[10, 11]]
      },
      'icon-size': {
        base: 1,
        stops: [
          [10, 0.1],
          [11, 0.2],
          [13, 0.3],
          [18, 0.4]
        ]
      }
    }},scopedSlots:_vm._u([{key:"popupHover",fn:function(slotProps){return [_c('vm-popup',{attrs:{"color":"#292929","text-color":"#ffffff","max-width":"350px","max-height":"300px"}},[_c('atrativos-popup',{attrs:{"size":"small","item":_vm.$get(slotProps, 'features[0].properties')}})],1)]}},{key:"popupClick",fn:function(slotProps){return [_c('vm-popup',{attrs:{"anchor":"bottom","color":"#292929","text-color":"#ffffff","max-width":"90vw","max-height":"90vh","id":"popup-full"}},[_c('atrativos-popup',{attrs:{"size":"big","item":_vm.$get(slotProps, 'features[0].properties')}})],1)]}}],null,false,125177991)})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }